import React, { Component } from "react";
import { install } from "resize-observer";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "./components/public/Login";
import {getToken} from './utils/CommonFunctions';
import ProtectedComponents from "./components/ProtectedRoutes/ProtectedComponents";
import {ProtectedRoute} from './components/ProtectedRoutes/protected.route';
import Register from "./components/public/Register";
import ForgotUserId from "./components/public/ForgotUserId";
import ResetPassword from "./components/public/ResetPassword";
import Activate from "./components/public/Activate";
import LoginRedirection from "./components/public/LoginRedirection";

import planTabContent from "./components/public/plans/planTabContent";
import GuestRecharge from "./components/public/guestRecharge";
import Services from "./components/ProtectedComponents/Services";
import NBNProtectedComponents from "./components/ProtectedRoutes/NBNProtectedComponents";
import NbnServiceList from "./components/ProtectedComponents/NBN/NbnServiceList";
import Service from "./components/ProtectedComponents/Services";
import PostPaidCommonModule from "./components/public/PostPaidCommonModule"
import PostPaidProtectedComponents from "./components/ProtectedRoutes/PostPaidProtectedComponents";
import PostPaidTapResaleCommonModule from "./components/public/PostPaidTapResaleCommonModule";
import Biometric from "./components/public/biometric/Biometric";
import PostPaidBiometric from "./components/public/biometric/PostPaidBiometric";
import BiometricSelfie from "./components/public/biometricSelfieVerification";
import PostPaidServiceList from "./components/ProtectedComponents/PostPaid/PostPaidServiceList";




///////////







install();

export default class App extends Component {
    
render() { 

  return (
    <> 
        
        <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
            <Switch>

                {(getToken() === null) ? 
                <Route exact path="/" component={Login} /> 
                : 
                <Route exact path="/" component={Services} />
                }

                <Route exact path="/Login" component={Login} />
                <Route exact path="/Register" component={Register} />
                <Route exact path="/ForgotUserId" component={ForgotUserId} />
                <Route exact path="/ResetPassword" component={ResetPassword} />
                <Route exact path="/Activate" component={Activate} />
                <Route exact path="/LoginRedirection" component={LoginRedirection} />
                <Route exact path="/secure_activation" component={PostPaidCommonModule} />
                <Route exact path="/secure_activation_postpaid_re_tap" component={PostPaidTapResaleCommonModule} />
                <Route exact path="/Biometric" component={Biometric} />
                <Route exact path="/wme-biometric" component={PostPaidBiometric} /> 
                <Route exact path="/biometric-verification" component={BiometricSelfie} /> 

      


                <Route exact path="/Plans" component={planTabContent} />
                <Route exact path="/service-list" component={Services} />
                <ProtectedRoute exact path="/my-service-list" component={PostPaidServiceList} />



                <ProtectedRoute exact path="/app" component={ProtectedComponents} />
                <ProtectedRoute exact path="/home" component={ProtectedComponents} />
                <ProtectedRoute exact path="/MyProfile" component={ProtectedComponents} />
                <ProtectedRoute exact path="/MyPayments" component={ProtectedComponents} />
                <ProtectedRoute exact sensitive path="/Recharge" component={ProtectedComponents} />
               
                <ProtectedRoute exact path="/AddaMobilePlan" component={ProtectedComponents} />
                <ProtectedRoute exact path="/ChangePassword" component={ProtectedComponents} />
                <ProtectedRoute exact path="/UsageHistory" component={ProtectedComponents} />
                <ProtectedRoute exact path="/IDverification" component={ProtectedComponents} />
                <ProtectedRoute exact path="/IDsuccess" component={ProtectedComponents} />
                <ProtectedRoute exact path="/DataGifting" component={ProtectedComponents} />
                <ProtectedRoute exact path="/ReferAbuddy" component={ProtectedComponents} />
                <ProtectedRoute exact path="/Esim" component={ProtectedComponents} />
                <ProtectedRoute exact path="/RechargeAFriend" component={ProtectedComponents} />
                <ProtectedRoute exact path="/RechargeHome" component={ProtectedComponents} />
                <ProtectedRoute exact path="/RechargeWithVoucher" component={ProtectedComponents} />
                <ProtectedRoute exact path="/MyServices" component={ProtectedComponents} />
                <Route exact path="/recharge-your-service" component={GuestRecharge} />
                <Route exact path="/AddNbn" component={ProtectedComponents} />
                <Route exact path="/connection" component={ProtectedComponents} />
                 

                {/*--------------------> NBN ROUTES <-------------------------------------------*/}
                <ProtectedRoute exact path="/nbn_services" component={NBNProtectedComponents} />
                <ProtectedRoute exact path="/nbn-my-account-summary" component={NBNProtectedComponents} />
                <ProtectedRoute exact path="/nbn_my_profile" component={NBNProtectedComponents} />
                <ProtectedRoute exact path="/nbn_my_payments" component={NBNProtectedComponents} />
                <ProtectedRoute exact path="/Activatev2" component={NBNProtectedComponents} />
                <ProtectedRoute exact path="/nbn_change_plan" component={NBNProtectedComponents} />
                <ProtectedRoute exact path="/nbn_change_password" component={NBNProtectedComponents} />
                <ProtectedRoute exact path="/nbn_add_a_mobile_plan" component={NBNProtectedComponents} />



                {/* --------------------Post Paid Routes--------------------------- */}

                <ProtectedRoute exact path="/post_paid_activate" component={ProtectedComponents} />
                {/* <ProtectedRoute exact path="/my-service-list" component={PostPaidProtectedComponents} /> */}
                <ProtectedRoute exact path="/account-summary" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/my-profile" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/my-payments" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/activatev3" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/change-plan" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/add-packs" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/add_a_mobile_plan" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/SImOnlyIDverification" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/SimOnlyIDsuccess" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/data-gifting" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/sim-services" component={PostPaidProtectedComponents} />
                 <ProtectedRoute exact sensitive path="/recharge" component={PostPaidProtectedComponents} />
                 <ProtectedRoute exact sensitive path="/sim-only-migration" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact  path="/service-migration" component={PostPaidProtectedComponents} />
              

               
                <Route exact path="/Add_Nbn" component={PostPaidProtectedComponents} />
                <Route exact path="/Nbn_connection" component={PostPaidProtectedComponents} />
                <ProtectedRoute exact path="/change_password" component={PostPaidProtectedComponents} />
               
















                
                

                
            </Switch>
        </BrowserRouter>

    </>
    )
}
}